import AgenciaBoletoService from "@/services/AgenciaBoletoService";

export const agenciaBoleto = {
  namespaced: true,
  state: {
    agenciaBoleto: {},
  },
  actions: {
    getAgenciaBoleto({ commit }, payload) {
      return AgenciaBoletoService.GetAgenciaBoleto(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    postAgenciaBoleto({ commit }, payload) {
      return AgenciaBoletoService.PostAgenciaBoleto(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    putAgenciaBoleto({ commit }, payload) {
      return AgenciaBoletoService.PutAgenciaBoleto(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    deleteAgenciaBoleto({ commit }, payload) {
      return AgenciaBoletoService.DeleteAgenciaBoleto(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    getAgenciaBoletoOData({ commit }, payload) {
      return AgenciaBoletoService.GetAgenciaBoletoOData(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error)
      );
    },
  },
  mutations: {},
};

export default agenciaBoleto;
